import { useEffect, useRef } from "react";

const partners = [
  {
    href: "https://www.vevey-streatfoodfest.ch/fr/vevey/Accueil/Bienvenue-au-Vevey-StrEAT-Food-Festival-2025.html",
    src: "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/9784fd53fde42de86bbe3e6f85bc0276.png",
    alt: "Beach Food Festival",
    brightness: false,
  },
  {
    href: "https://www.veveynoel.ch/",
    src: "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/d40ba10f7d7cc5c9fe6908e0754a78fb.png",
    alt: "Vevey Noël",
    brightness: false,
  },
  {
    href: "https://www.veveyrivieranoel.com/",
    src: "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/b107ec3779e4175d8d13758e28072c42.png",
    alt: "Riviera Noël",
    brightness: false,
  },
  {
    href: "",
    src: "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/6fb3f452805d92f0f2b79b972bce3a5d.svg",
    alt: "Commune de Vevey",
    brightness: false,
  },
  {
    href: "https://www.fetedesvignerons.ch/amisdelafevi/",
    src: "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/fff102b57bdbc66d8f2d2afa908df07c.png",
    alt: "Amis de la Fête de Vevey",
    brightness: false,
  },
  {
    href: "https://www.confreriedesvignerons.ch/",
    src: "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/2ae383dd74e94fc5b943cb5489a8e23b.png",
    alt: "Vignerons de Vevey",
    brightness: false,
  },
  {
    href: "https://www.leguriviera-groupe.ch/",
    src: "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/ccd213724bad459e2970874def342859.jpeg",
    alt: "Légurivera",
    brightness: false,
  },
  {
    href: "",
    src: "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/79a9e92eeb8e82b25309ed5984fa080c.png",
    alt: "Paradise",
    brightness: false,
  },
  {
    href: "https://socialife.ch/",
    src: "https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/eeccb251dbf99237cc0b0e03cc4c3f0d.jpeg",
    alt: "Socialife",
    brightness: false,
  },
];

export default function PartnersSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("opacity-100", "translate-y-0");
          el.classList.remove("opacity-0", "translate-y-8");
        }
      },
      { threshold: 0.1 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="partenaires"
      ref={sectionRef}
      className="pt-0 pb-0 relative opacity-0 translate-y-8 transition-all duration-700 bg-background-50"
    >
      <div className="pt-10 md:pt-16 pb-10 md:pb-14">
        <div className="max-w-5xl mx-auto px-2 relative z-10">
          <div className="text-center mb-0 md:mb-14">
            <h2 className="text-center font-playfair text-2xl md:text-4xl lg:text-[2.75rem] font-bold text-terracotta mb-8 md:mb-10 tracking-tight">
              ILS NOUS FONT CONFIANCE
            </h2>
          </div>

          <div className="bg-white border-2 border-[#8B3B3B]/40 rounded-2xl p-10 md:p-12 transition-all duration-700 shadow-[0_4px_24px_rgba(0,0,0,0.03)] hover:shadow-[0_12px_40px_rgba(139,59,59,0.08)]">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-10 md:gap-14">
              {partners.map((partner) =>
                partner.href ? (
                  <a
                    key={partner.href}
                    href={partner.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center p-3 transition-all duration-300 hover:scale-105"
                  >
                    <img
                      src={partner.src}
                      alt={partner.alt}
                      className={`h-[90px] md:h-[115px] w-auto max-w-[155px] md:max-w-[200px] object-contain ${partner.brightness ? "brightness-0" : ""}`}
                    />
                  </a>
                ) : (
                  <div
                    key={partner.alt}
                    className="flex items-center justify-center p-3 transition-all duration-300 hover:scale-105 cursor-default"
                  >
                    <img
                      src={partner.src}
                      alt={partner.alt}
                      className={`h-[90px] md:h-[115px] w-auto max-w-[155px] md:max-w-[200px] object-contain ${partner.brightness ? "brightness-0" : ""}`}
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}